<template>
  <basic-container>

      <!-- :search.sync="query"  -->
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="()=>{
        initSearchData(function(res){
            query.parkingLotId = res.data[0].id;
            onLoad();
        });

      }"
      @refresh-change="onLoad"
    >

      <template slot-scope="scope" slot="carParkNumberNew">
          <wq-overHidden :content="scope.row.carParkNumber">
                  <span>{{scope.row.carParkNumber}}</span>
          </wq-overHidden>
      </template>

      <template slot-scope="scope" slot="regionIdSearch">
        <el-select
                  clearable
                  v-model="query.regionId"
                  placeholder="区域名称"
                  filterable
                  style="width: 100%"
                >
                  <el-option
                    v-for="(item, index) in regionList"
                    :key="index"
                    :label="item.spaceName"
                    :value="item.id"
                  ></el-option>
                </el-select>
      </template>


      <template slot-scope="scope" slot="parkingLotIdSearch">
        <el-select
                  @change="spaceIdChange"
                  v-model="query.parkingLotId"
                  placeholder="车场名称"

                  style="width: 100%"
                >
                  <el-option
                    v-for="(item, index) in carParkList"
                    :key="index"
                    :label="item.spaceName"
                    :value="item.id"
                  ></el-option>
                </el-select>
      </template>


      <template slot-scope="scope" slot="regionIdForm">
        <el-select
        :disabled="regionFlag"
                  clearable
                  v-model="form.regionId"
                  placeholder="合同对象"
                  filterable
                  style="width: 100%"
                >
                  <el-option
                    v-for="(item, index) in regionList"
                    :key="index"
                    :label="item.spaceName"
                    :value="item.id"
                  ></el-option>
                </el-select>
      </template>


      <template slot-scope="scope" slot="parkingLotIdForm">
        <el-select
        :disabled="parkingLotFlag"
                  clearable
                  @change="spaceIdChange_"
                  v-model="form.parkingLotId"
                  placeholder="合同对象"
                  filterable
                  style="width: 100%"
                >
                  <el-option
                    v-for="(item, index) in carParkList"
                    :key="index"
                    :label="item.spaceName"
                    :value="item.id"
                  ></el-option>
                </el-select>
      </template>
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-top"
          plain
          v-if="permissionList.syncBtn"
          @click="handleSync"
        >同步下发
        </el-button>
      </template>
      <template slot="carParkGroupNameNew" slot-scope="scope">
          <wq-overHidden :content="scope.row.carParkGroupName">
                  <span>{{scope.row.carParkGroupName}}</span>
          </wq-overHidden>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
    import {add,
      getDetail,
      getList,
      remove,
      update,
      syncCarParkGroup,
      getCarParkList,
      getRegionList} from "@/api/v4ward/car/carparkgroup";
    import {mapGetters} from "vuex";

    export default {
      data: function () {
        return {
          regionFlag:false,
          parkingLotFlag:false,
          form: {},
          query: {},
          search:{},
          regionList:[],
          parkingLotList:[],
          loading: true,
          reWrite: false,
          firstDisplayFlag:false,
          tempCarParkId: '',
          carParkList: [],
          page: {
            pageSize: 10,
            currentPage: 1,
            total: 0
          },
          selectionList: [],
          option: {
            height: 'auto',
            calcHeight: 50,
            tip: false,
            border: true,
            indexLabel:'序号',
            index: true,
            viewBtn: true,
            selection: true,
            columnBtn: false,
            refreshBtn: false,
            delBtn:true,
            searchMenuSpan: 6,
            dialogClickModal:false,
            column: [
              {
                label: "主键",
                prop: "id",
                editDisplay: false,
                addDisplay: false,
                viewDisplay: false,
                hide: true,
                width: 90,
              },
              {

                label: "车场名称",
                prop: "spaceName",
                width: 90,
                editDisplay: false,
                addDisplay: false,
                viewDisplay: false,
                search: false,
              },
              {
                label: "车场名称",
                prop: "parkingLotId",
                type: 'tree',
                disabled: true,
                formslot: true,
                searchClearable:false,
                hide: true,
                search: true,
                searchslot: true,
                width: 90,
                searchSpan: 6,
                props: { label: 'spaceName', value: 'id' },
                rules: [{
                  required: true,
                  message: "请选择车场名称",
                  trigger: "change"
                }]
              },
              {
                label: "区域名称",
                prop: "regionId",
                type: 'tree',
                searchClearable:false,
                formslot: true,
                search: true,
                searchslot:true,
                width: 90,
                searchSpan: 6,
                hide:true,
                props: { label: 'spaceName', value: 'id' },
                rules: [{
                  required: true,
                  message: "请选择车场名称",
                  trigger: "change"
                }]
              },

              {
                label: "区域名称",
                prop: "regionName",
                type: 'tree',
                searchClearable:false,
                editDisplay: false,
                addDisplay: false,
                viewDisplay: false,
                width: 90,
                searchSpan: 6,
                props: { label: 'spaceName', value: 'id' },
                rules: [{
                  required: true,
                  message: "请选择车场名称",
                  trigger: "blur"
                }]
              },

              {
                label: "车位组名称",
                prop: "carParkGroupNameNew",
                slot:true,
                editDisplay: false,
                addDisplay: false,
                viewDisplay: false,
                span: 12,
                width: 90,
                rules: [{
                  required: true,
                  message: "请输入车位组名称",
                  trigger: "blur"
                }]
              },
              {
                label: "车位数",
                prop: "carParkNumberNew",
                slot: true,
                editDisplay: false,
                addDisplay: false,
                viewDisplay: false,
                span: 12,
                width: 90,
                type:'number',
                maxlength:10,
                rules: [{
                  required: true,
                  message: "请输入车位数",
                  trigger: "blur"
                }]
              },
              {
                label: "截至时间",
                prop: "endTimeRange",
                searchSpan: 6,
                width: 90,
                type: "datetimerange",
                defaultTime:['00:00:00','23:59:59'],
                showColumn:false,
                startPlaceholder:'开始时间',
                endPlaceholder:'结束时间',
                format: "yyyy-MM-dd HH:mm:ss",
                valueFormat: "yyyy-MM-dd HH:mm:ss",
                searchRange:true,
                hide: true,
                search: true,
                rules: [{
                  required: true,
                  message: "请输入通知时间",
                  trigger: "blur"
                }],
                change:({value,column})=>{
                  console.log(this);
                  console.log(value,column);
                },
              },
              {
                label: "责任人",
                prop: "responsiblePersonName",
                search: true,
                display: true,
                type:'input',
                maxlength:20,
                span: 12,
                width: 90,
                rules: [{
                  required: true,
                  message: "请输入责任人",
                  trigger: "blur"
                }]
              },
            {
                label: "责任人电话",
                prop: "responsiblePersonPhone",
                display: true,
                span: 12,
                width: 90,
                rules: [{
                  required: true,
                  message: "请输入责任人电话",
                  trigger: "blur"
                },
                { type : "string" , required: true , pattern : /^1(3|4|5|6|7|8|9)\d{9}$/,
                  message: "责任人电话格式错误", }]
              },
              {
                label: "车牌号",
                prop: "plateNumbers",
                viewDisplay: false,
                editDisplay: false,
                addDisplay: false,
                search: true,
                span: 12,
                width: 90,
                hide:true,
                rules: [{
                  required: true,
                  message: "请输入车牌号",
                  trigger: "blur"
                }]
              },
              {
                label: "车位组名称",
                prop: "carParkGroupName",
                type:'input',
                maxlength:20,
                display: true,
                hide:true,
                span: 12,
                width: 90,
                rules: [{
                  required: true,
                  message: "请输入车位组名称",
                  trigger: "blur"
                }]
              },
              {
                label: "车位数",
                prop: "carParkNumber",
                display: true,
                hide: true,
                span: 12,
                width: 90,
                type:'input',
                maxlength:10,
                rules: [{
                  required: true,
                  message: "请输入车位数",
                  trigger: "blur"
                },
                { type : "string" , required: true , pattern : /^[0-9]+$/,
                  trigger: "change",
                  message: "车位数格式错误", }]
              },
              {

                label: "车牌号",
                prop: "plateNumberList",
                type: 'textarea',
                span: 24,
                row: 4,
                maxlength: 7200,
                showWordLimit: true,
                overHidden: true,
                rules: [{
                  required: true,
                  message: "请输入车牌号",
                  trigger: "blur"
                }]
              },
              // {
              //   label: "备注信息",
              //   prop: "remark",
              //   type: 'textarea',
              //   span: 24,
              //   row: 4,
              //   maxlength: 100,
              //   showWordLimit: true,
              //   overHidden: true,
              // },
            ]
          },
          data: []
        };
      },
        computed: {
            ...mapGetters(["permission"]),
            permissionList() {
                return {
                    addBtn: this.vaildData(this.permission.carParkGroup_add, false),
                    viewBtn: this.vaildData(this.permission.carParkGroup_view, false),
                    delBtn: this.vaildData(this.permission.carParkGroup_delete, false),
                    editBtn: this.vaildData(this.permission.carParkGroup_edit, false),
                    syncBtn: this.vaildData(this.permission.carParkGroup_sync, false)
                };
            },
            ids() {
                let ids = [];
                this.selectionList.forEach(ele => {
                    ids.push(ele.id);
                });
                return ids.join(",");
            }
        },
      watch: {
        'form.matchType'() {
          if (this.form.matchType === 1) {
            this.findObject(
              this.option.column,
              'numberFrom'
            ).display = true;
            this.findObject(
              this.option.column,
              'numberTo'
            ).display = true;

            this.findObject(
              this.option.column,
              'numberFromOne'
            ).display = false;
            this.findObject(
              this.option.column,
              'numberToOne'
            ).display = false;
          }
          if (this.form.matchType === 2) {
            this.findObject(
              this.option.column,
              'numberFrom'
            ).display = false;
            this.findObject(
              this.option.column,
              'numberTo'
            ).display = false;

            this.findObject(
              this.option.column,
              'numberFromOne'
            ).display = true;
            this.findObject(
              this.option.column,
              'numberToOne'
            ).display = true;
          }
        },
      },
      created() {
        let self = this;
        self.initSearchData(function(res){
            self.query.parkingLotId = res.data[0].id;
            console.log("self.query=================>",self.query);
          getRegionList({spaceId:self.carParkList[0].id}).then((res)=>{
            self.regionList = res.data;
            // this.query.regionId = res.data[0].id;
          });
        });
      },
      methods: {
        spaceIdChange_(val){
          this.form = Object.assign({},this.form,{
            parkingLotId: val
          });
          let self = this;
              this.form = Object.assign({},this.form,{
                regionId: ''
              });

            self.regionList = [];
          getRegionList({spaceId:val}).then((res)=>{
            self.regionList = res.data;
            if(res.data.length>0){
              this.form = Object.assign({},this.form,{
                regionId: res.data[0].id
              });
            }
          });
        },
        spaceIdChange(val){
          console.log('spaceIdChange===========>',val);
          this.query = Object.assign({},this.query,{
            parkingLotId: val
          });
          let self = this;
              this.query = Object.assign({},this.query,{
                regionId: ''
              });
              console.log(this.query);
          getRegionList({spaceId:val}).then((res)=>{
            self.regionList = res.data;
            if(res.data.length>0){
              this.query = Object.assign({},this.query,{
                regionId: res.data[0].id
              });
            }
          });
        },
        initSearchData(callback){
          getCarParkList().then((res)=>{
            console.log(res);
            this.carParkList = res.data;
            callback(res);
          })
        },
        getCarParkNameById(carParkId) {
          console.log();
          let carParkName = '';
          this.carParkList.forEach(function (value, index, array) {
            if (value.id === carParkId) {
              carParkName = value.spaceName;
              // return;
            }
          });
          return carParkName;
        },
        rowSave(row, loading, done) {
          console.log('rowSave====================>',row);
          row.carParkStartTime = row.endTimeRange[0];
          row.carParkEndTime = row.endTimeRange[1];
          add(row).then(
            () => {
              loading();
              this.onLoad();
              this.$message.success('操作成功!');
            },
            (error) => {
              done();
              console.log(error);
            }
          );
        },
        rowUpdate(row, index, loading, done) {
          console.log('rowSave====================>',row);
          row.carParkStartTime = row.endTimeRange[0];
          row.carParkEndTime = row.endTimeRange[1];
          update(row).then(
            () => {
              loading();
              this.onLoad();
              this.$message.success('操作成功!');
            },
            (error) => {
              done();
              console.log(error);
            }
          );
        },
        rowDel(row) {
          this.$confirm('确定将选择数据删除?', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              return remove({ ids: row.id });
            })
            .then(() => {
              this.onLoad();
              this.$message.success('操作成功!');
            });
        },
        handleSync() {
          if (this.selectionList.length === 0) {
            this.$message.warning('请选择至少一条数据');
            return;
          }
          this.$confirm('确定将选择数据同步?', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              return syncCarParkGroup({ ids: this.ids , parkingLotId:this.query.parkingLotId});
            })
            .then(() => {
              this.onLoad();
              this.$message.success('操作成功!');
              this.$refs.crud.toggleSelection();
            });
        },
        beforeOpen(done, type) {
          let self = this;
              this.regionFlag = false;
              this.parkingLotFlag = false;
          if (['edit', 'view'].includes(type)) {
              this.parkingLotFlag = true;
            if (['view'].includes(type)) {
              this.regionFlag = true;
            }
            getDetail({ id: this.form.id }).then(({ data }) => {
              this.form = data;
              let startArr = self.form.carParkStartTime.split('T');
              let endArr = self.form.carParkEndTime.split('T');
              this.form.endTimeRange = [startArr[0],endArr[0]];
              console.log('this.edit.form>>>>>', this.form);
            });
          }else {
            let self = this;
            this.form.parkingLotId = this.query.parkingLotId;
            this.form = Object.assign({},self.form,{
              parkingLotId:self.query.parkingLotId
            })
            console.log("beforeOpen==============>",type);
          }
          done();
        },
        searchReset() {
          console.log("========query==========>",this.query);
          let parkingLotId = this.query.parkingLotId;
          this.query = Object.assign({},this.query,{
            parkingLotId: parkingLotId,
            regionId: '',
            startTime: '',
            endTime: '',
            responsiblePersonName:'',
            responsiblePersonPhone:'',
            endTimeRange:[],
            plateNumbers:''
          });
          this.firstDisplayFlag = true;
          this.onLoad();
        },
        searchChange(params, done) {
          console.log("params==============>",params);
          let self = this;
          self.query = {
            parkingLotId: self.query.parkingLotId,
            regionId: self.query.regionId,
          }
          this.query = Object.assign({},this.query,params);
          this.page.currentPage = 1;
          console.log("this.query========>",this.query);
          if(params.endTimeRange&&params.endTimeRange.length>0){
            this.query.startTime = this.query.endTimeRange[0];
            this.query.endTime = this.query.endTimeRange[1];
          }

          this.onLoad();
          done();
        },
        selectionChange(list) {
          this.selectionList = list;
        },
        selectionClear() {
          this.selectionList = [];
          this.$refs.crud.toggleSelection();
        },
        currentChange(currentPage) {
          this.page.currentPage = currentPage;
        },
        sizeChange(pageSize) {
          this.page.pageSize = pageSize;
        },
        onLoad(page) {
          let self = this;
          page = page || this.page;
          this.loading = true;
          //如果加载列表时propertyParentId为空，则将propertyParentId置为当前的第一个房产小区
          if (!this.query.parkingLotId ) {
            console.log('this.query.parkingLotId===========>',this.query.parkingLotId);
            this.query.parkingLotId = this.tempCarParkId;
          }
          getList(
            Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
          ).then(({data}) => {
            this.page.total = data.total;
            this.data = data.records;
            this.loading = false;
            this.selectionClear();
            if (this.firstDisplayFlag) {
              let ent = document.querySelector('input[placeholder="车场名称"]');
              ent.value = this.getCarParkNameById(self.query.parkingLotId);
              this.tempCarParkId = this.query.parkingLotId;
              //关闭默认显示，重刷页面时才开启默认显示
              this.firstDisplayFlag = false;
            }
          });
        }
      },
    };
</script>

<style>
.tooltipContent{
    width: 70px;

    height: 57px;

    overflow: hidden;

    text-overflow: ellipsis;

    display: -webkit-box;

    -webkit-line-clamp: 2;

    -webkit-box-orient: vertical;
}
</style>
